module.exports = __webpack_public_path__ + "static/media/DimitriosMarkou.fd706efe.jpg";